import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ZuperAlertComponent } from './zuper-alert.component';

@NgModule({
    declarations: [
        ZuperAlertComponent
    ],
    imports     : [
        CommonModule,
        MatButtonModule,
        MatIconModule
    ],
    exports     : [
        ZuperAlertComponent
    ]
})
export class ZuperAlertModule
{
}
